import utils from './utils';
// const mallTest = utils.getUrlParam('mallTest') || '';
const pvareaid = utils.getUrlParam('pvareaid') || '';
const adChannel = utils.getUrlParam('adChannel') || '';

const baseParams = {
    area: 'middle',
    element: 'details',
    pmark: 1
};
const ep = {
    userId: utils.getCookie('userId'),
    time: new Date().getTime(),
    // mallTest,
    pvareaid,
    adChannel
};

export default { baseParams, ep }